import { render, staticRenderFns } from "./WidgetDeviceSummary.vue?vue&type=template&id=466e89bc&scoped=true&"
import script from "./WidgetDeviceSummary.vue?vue&type=script&lang=js&"
export * from "./WidgetDeviceSummary.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDeviceSummary.vue?vue&type=style&index=0&id=466e89bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466e89bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('466e89bc')) {
      api.createRecord('466e89bc', component.options)
    } else {
      api.reload('466e89bc', component.options)
    }
    module.hot.accept("./WidgetDeviceSummary.vue?vue&type=template&id=466e89bc&scoped=true&", function () {
      api.rerender('466e89bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/widgets/WidgetDeviceSummary.vue"
export default component.exports